import React from 'react';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const CardContainer = ({ category, pdfUrl, subject, summary, title }) => {

  const colors = {
    primary: category === '1' ? '#f2642f'
      : category === '2' ? '#f8c12c'
        : category === '3' ? '#99d6ce'
          : '#28b45f',
    secondary: category === '1' ? '#f15728'
      : category === '2' ? '#dda218'
        : category === '3' ? '#7bbfb6'
          : '#0c984b',
    secondarySmallText: category === '1' ? '#f1b4a1'
        : category === '2' ? '#e6c577'
            : category === '3' ? '#a0d6cf'
                : '#69d69f',
  };

  const useStyles = makeStyles(() => ({
    card: {
      maxWidth: 400,
      // backgroundColor: '#242424',
      // width: 410,
      height:275,
      margin: '5px',
      border: `2px ${colors.primary} solid`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      position: 'relative',
    },
    media: {
      height: 139,
      width: 120
    },
    title: {
      color: 'white',
      marginTop: '10px',
      fontSize: '22px'
    },
    subtitle: {
      fontSize: '14px',
      color: colors.secondarySmallText
    },
    summary: {
      margin: '5px',
      minHeight: 100,
      padding:10
    },
    button: {
      // height: '50px',
      marginTop: '5px',
      color: 'black',
      backgroundColor: colors.primary,
      border: `1px solid ${colors.primary}`,
      position:'absolute',
      left:0,
      bottom:0,
      borderRadius: 0,
      '&:hover': {
        backgroundColor: colors.secondary,
        color: 'white',
        border: `1px solid white`,
      },
    },
  }));


  const handleOpen = (pdfUrl) => {
    // if (pdfUrl.indexOf('.pdf')>0){
    //   downloadFile(pdfUrl);
    // } else {
    // }
    window.open(pdfUrl);
  };

  // const downloadFile = function(url){
  //   let a = document.createElement('a');
  //   //data:application/pdf;charset=UTF-8,
  //   a.href = 'data:application/pdf,' + '' + url;
  //   a.download = url.substr(url.lastIndexOf('/') + 1);
  //   document.body.appendChild(a);
  //   a.click();
  //   document.body.removeChild(a);
  // }

  const classes = useStyles();
  return (
    <Card className={classes.card}>
      <div style={{ backgroundColor: '#283f60', width: '100%', marginBottom: '5px' }}>
        <Typography className={classes.title} variant="h5" component="h2">
          {title}
        </Typography>
        <Typography className={classes.subtitle} gutterBottom variant="body2" color="textSecondary" component="p">
          {subject}
        </Typography>
      </div>
      <Typography className={classes.summary}>
        {summary}
      </Typography>
        <Button
          fullWidth
          className={classes.button}
          onClick={() => handleOpen(pdfUrl)}
          variant='contained'
        >
          View
        </Button>
    </Card>
  );
};

export default CardContainer;
